
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ARFOCAAA",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ARFOCAAA.vue